export const landing2 = {
  navigation: {
    home: "Home",
    features: "How?",
    pricingAndExperiences: "What?",
    about: "Who?",
    contact: "Contact",
    login: "Login",
    benefits: "Benefits",
    getStarted: "Get Started",
    pricing: "Pricing",
  },
  languages: [
    { code: "HU", name: "Magyar", flag: "🇭🇺" },
    { code: "EN", name: "English", flag: "🇬🇧" },
    { code: "DE", name: "Deutsch", flag: "🇩🇪" },
    { code: "FR", name: "Français", flag: "🇫🇷" },
    { code: "IT", name: "Italiano", flag: "🇮🇹" },
  ],
  hero: {
    title: "AI assistant",
    dynamicWords: ["generates content", "optimizes", "builds community", "automates", "works for you", "grows revenue"],
    subtitle: "while you create",
    description: "An intelligent partner that supports your online presence while you focus on what you do best.",
    cta: "Get started now"
  },
  steps: {
    mainTitle: "Fast, simple, secure",
    subtitle: "",
    aiTitle: "How it works in practice",
    aiSteps: [
      "Free registration",
      "Identify yourself",
      "AI helps you in everything to work more efficiently"
    ],
    focusTitle: "The AI assistant works 24/7 for you",
    tryButton: "Try it now",
    items: [
      {
        title: "Automatic content",
        description: "Generates posts and websites for you."
      },
      {
        title: "Analytics",
        description: "Monitors and optimizes your sales."
      },
      {
        title: "Community building",
        description: "Helps you understand and activate your followers."
      },
      {
        title: "Automations",
        description: "Sets up your products, handles all payments for you."
      }
    ]
  },
  whatToSell: {
    title: "What Can You Sell?",
    subtitle: "Any digital product or service",
    digital: "Digital Products",
    services: "Services and Experiences",
    digitalItems: [
      {
        title: "Video Content",
        description: "Tutorials, vlogs, exclusive recordings"
      },
      {
        title: "Digital Books",
        description: "E-books, guides, recipe collections"
      },
      {
        title: "Images & Graphics",
        description: "Stock photos, stickers, GIFs, design elements"
      },
      {
        title: "Audio Content",
        description: "Music, podcasts, audiobooks, meditations"
      }
    ],
    experiences: [
      {
        title: "Group Meetings",
        description: "Organize interactive events, workshops, or group consultations with your community members – either online via video call or in person."
      },
      {
        title: "Individual Consultations",
        description: "Personalized one-on-one coaching and mentoring – online via video call or in-person meeting, as an expert in your field."
      },
      {
        title: "Workshops",
        description: "Interactive educational experiences with live demonstrations and exercises for small groups – online or at offline venues."
      },
      {
        title: "Ticket Sales",
        description: "Sell tickets for your concerts, fitness classes, performances, or any events – all in one place, simply."
      },
      {
        title: "Exclusive Content",
        description: "Special access to extra materials, early releases, or private community content."
      },
      {
        title: "Personal Video Messages",
        description: "Send unique, personalized videos to your followers – whether it's a birthday greeting, inspiring message, or quick video advice on a specific topic."
      },
      {
        title: "Private Messages",
        description: "Answer your followers' questions in writing – whether it's advice, confirmation, or even inspiration. Perfect choice if you want to provide valuable support in a quick and efficient format."
      }
    ]
  },
  personas: {
    title: "One platform for every creator",
    subtitle: "Some examples of how others are using Bespire",
    examplesLabel: "What you get:",
    cta: "See what it can offer you",
    items: [
      {
        title: "Content Creators",
        description: "You just create – we generate your website, analyze your followers' reactions, and automatically handle payments.",
        examples: ["What to post?", "When to post?", "Full website", "Subscription"]
      },
      {
        title: "Makeup Artists",
        description: "Showcase your before-after work on a pro website! We handle bookings while you focus on beauty.",
        examples: ["Thumbnail / Cover image", "Landing page", "Brand partnerships", "Analytics"]
      },
      {
        title: "Healthcare Professionals",
        description: "Build trust with an expert online presence – website, content and appointment management fully automated.",
        examples: ["What to post?", "Full website", "Social platform trends", "Analytics"]
      },
      {
        title: "Personal Trainers",
        description: "Selling your coaching programs has never been easier! Motivate, inspire, and we handle the rest.",
        examples: ["When to post?", "Giveaway/Challenge", "Subscription", "Repurposing"]
      },
      {
        title: "Musicians",
        description: "Your concerts, merchandising, unique tracks – all in one place! Build community, we support growth.",
        examples: ["Thumbnail / Cover image", "Brand partnerships", "Monetization & offers", "Social platform trends"]
      },
      {
        title: "Chefs",
        description: "Share your recipes and cooking skills! AI analyzes what interests people most, then you can teach it.",
        examples: ["What to post?", "Thumbnail / Cover image", "Landing page", "Repurposing"]
      },
      {
        title: "Teachers",
        description: "Teach more effectively! Create materials, track student progress, automate enrollment.",
        examples: ["Full website", "What to post?", "Subscription", "Analytics"]
      },
      {
        title: "Psychologists",
        description: "Help others with peace of mind – appointments, billing, communication all automated.",
        examples: ["Landing page", "Social platform trends", "When to post?", "Analytics"]
      },
      {
        title: "Business Consultants",
        description: "Grow your clients' business, we grow yours! Lead management, mentoring sales – seamlessly.",
        examples: ["Full website", "Brand partnerships", "Monetization & offers", "Analytics"]
      },
      {
        title: "Lifestyle Coaches",
        description: "Inspire, motivate, change lives! Build your wellness empire with AI support.",
        examples: ["What to post?", "Giveaway/Challenge", "Subscription", "Social platform trends"]
      },
      {
        title: "Gamers",
        description: "Stream, community, exclusive content – on one platform! Find your fans and sell to them easily.",
        examples: ["Thumbnail / Cover image", "When to post?", "Repurposing", "Subscription"]
      }
    ]
  },
  benefits: {
    title: "Why use an AI assistant?",
    items: [
      {
        title: "Save time",
        description: "AI does what you had to do manually. Content creation, scheduling, optimization – all automatic."
      },
      {
        title: "Earn more revenue",
        description: "Every process is optimized for conversion. AI monitors trends and automatically improves performance."
      },
      {
        title: "Everything becomes simple",
        description: "No separate website, payment, and billing system – everything in one place. Manage everything simply in one place."
      },
      {
        title: "Focus on what matters",
        description: "You focus on content and your audience while AI handles the backend work and administration."
      }
    ]
  },
  stats: {
    title: "Join Us",
    subtitle: "And shape the future with us",
    items: [
      { value: "Let", label: "yours be the next success story" },
      { value: "Build", label: "your creator business today" },
      { value: "Find", label: "your path to success" },
      { value: "Realize", label: "your dreams with us" }
    ]
  },
  signup: {
    title: "Bespire Creative Platform",
    subtitle: "Join us and shape the future with us. Early creators get special benefits.",
    cta: "Start Now",
  },
  faq: {
    title: "Frequently Asked Questions",
    questions: [
      {
        question: "How much does the service cost? Is there a free trial?",
        answer: "Website generation and testing is completely free, no registration required. After going live, the platform uses commission-based pricing with no hidden fees. Early users get special discounts."
      },
      {
        question: "Does the platform support international reach and payments?",
        answer: "Yes. Bespire helps creators with multi-language interface, automatic billing/tax compliance, and global payment solutions, so you can sell your content from anywhere."
      },
      {
        question: "What types of products can I sell?",
        answer: "You can sell digital products like videos, e-books, audio content, images, as well as services like personal consultations, workshops, online meetings, and personalized video messages."
      },
      {
        question: "How quickly can I start selling?",
        answer: "Your website will be ready in minutes! Our AI assistant helps you set up everything quickly, and you can start selling immediately after your site goes live."
      },
      {
        question: "Do I need technical knowledge to use the platform?",
        answer: "No technical knowledge required! Our AI assistant guides you through the entire process via chat. You just answer a few questions and the AI creates your website automatically."
      },
      {
        question: "How does payment processing work?",
        answer: "Bespire handles all payment processing, billing, and tax compliance automatically. Your customers can pay securely with credit cards, and you receive your earnings regularly."
      },
      {
        question: "Can I customize my website design?",
        answer: "Absolutely! You can fully customize your website - colors, logo, content, and even use your own domain name. The AI assistant helps you personalize everything through simple chat commands."
      },
      {
        question: "How can I get help?",
        answer: "24/7 customer support is available. You can reach us through the contact form, email, or live chat – we respond quickly to all questions."
      }
    ],
  },
  contact: {
    title: "Have a question?",
    subtitle: "Feel free to write to us!",
    responseTime: "We respond within 24 hours",
    email: "info@bespire.io"
  },
  animatedChat: {
    aiName: "Bespire AI Assistant",
    status: "Online",
    mostActive: "Most active",
    welcome: "Hi! I'll help you create the perfect creator website. Tell me what kind of content you create!",
    userResponse1: "I'm a music producer, I make electronic music and teach online courses",
    aiResponse1: "Fantastic! Electronic music and education... What style design would you like? Modern-minimal or vibrant-energetic?",
    userResponse2: "Vibrant and energetic! Dark background with neon accents",
    aiResponse2: "Perfect! Generating your cyberpunk-style website... It'll be ready in minutes!",
    userLabel: "You",
  },
  paymentMethods: {
    title: "Your customers can pay you this way",
    subtitle: "All payment methods will be automatically available on your website"
  },
  affiliate: {
    badge: "Extra income",
    title: "Affiliate Program",
    description: "Would you like to recommend Bespire to others? Share the platform and earn commission on every successful registration.",
    partnerProgram: "Partner Program",
    affiliateProgram: "Affiliate program", 
    aboutUs: "About Us",
    legal: "Legal",
    newsletterSuccess: "Thank you for subscribing! We will send newsletters soon.",
    ctaTitle: "Start earning now",
    ctaDescription: "Revenue can start with just sharing a simple link",
    ctaButton: "Program details"
  },
  footer: {
    support: "Support",
    newsletter: "Newsletter",
    newsletterDescription: "Be among the first to learn about new features and opportunities.",
    emailPlaceholder: "Your email address",
    subscribe: "Subscribe",
    privacy: "Privacy Policy",
    terms: "Terms of Service",
    copyright: "© 2025 Bespire. All rights reserved.",
    madeWithLove: "Made with ❤️ for creators",
    systemStatus: "All systems operational",
    privacyAlert: "Privacy policy coming soon!",
    termsAlert: "Terms of service coming soon!"
  }
};